import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

import {
  setCertifications,
  setEducation,
} from "../../../redux/actions/dataCollectionAction";

export default function AddEducationModal({
  type,
  modalTitle,
  openModal,
  handleAddFormationClose = () => {},
}) {
  const [title, setTitle] = useState("");
  const [institute, setInstitute] = useState("");
  const [period, setPeriod] = useState("");

  const dispatch = useDispatch();
  const dataCollection = useSelector((state) => state.dataCollection);

  const addNewFormation = (newDiplome, newInstitute, newPeriode) => {
    const parentsListArray =
      (type === "formation"
        ? dataCollection?.Education
        : dataCollection?.Certifications) || [];
    const newListArray = [
      ...parentsListArray,
      {
        Title: newDiplome,
        Institute: newInstitute,
        Period: newPeriode,
      },
    ];

    if (type === "formation") {
      dispatch(setEducation(newListArray));
    }
    if (type === "certification") {
      dispatch(setCertifications(newListArray));
    }
    handleAddFormationClose();
  };

  useEffect(() => {
    setTitle("");
    setInstitute("");
    setPeriod("");
  }, [openModal]);

  return (
    <Modal show={openModal} onHide={handleAddFormationClose}>
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            bgcolor: "#200A5F",
            color: "#200A5F",
          }}
        >
          {modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-1">
            <Form.Label size="sm" color="primary">
              <span
                style={{
                  fontstyle: "oblique",
                  bgcolor: "#200A5F",
                  color: "#200A5F",
                }}
              >
                Diplôme
              </span>
            </Form.Label>
            <div className="row">
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <Grid mb={1}>
                      <Form.Control
                        xm={1}
                        size="sm"
                        type="text"
                        value={title}
                        placeholder="diplôme"
                        autoFocus
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label size="sm" color="primary">
              <span
                style={{
                  fontstyle: "oblique",
                  bgcolor: "#200A5F",
                  color: "#200A5F",
                }}
              >
                Etablissement
              </span>
            </Form.Label>
            <div className="row">
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <Grid mb={1}>
                      <Form.Control
                        xm={1}
                        size="sm"
                        type="text"
                        value={institute}
                        placeholder="Etablissement"
                        onChange={(e) => setInstitute(e.target.value)}
                      />
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </Form.Group>

          <Form.Group className="mb-1">
            <Form.Label size="sm" color="primary">
              <span
                style={{
                  fontstyle: "oblique",
                  bgcolor: "#200A5F",
                  color: "#200A5F",
                }}
              >
                Période
              </span>
            </Form.Label>
            <div className="row">
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <Grid mb={1}>
                      <Form.Control
                        xm={1}
                        size="sm"
                        type="text"
                        value={period}
                        placeholder="période"
                        onChange={(e) => setPeriod(e.target.value)}
                      />
                    </Grid>
                  </div>
                </div>
              </div>
            </div>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-xs-3"></div>

        <Button
          style={{
            textTransform: "capitalize",
            border: "2px solid transparent",
            borderColor: "#DA2889",
            fontweight: "bold",
            borderRadius: "5px",
          }}
          sx={{ bgcolor: "#DA2889", color: "white" }}
          onClick={() => addNewFormation(title, institute, period)}
        >
          Enregistrer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
